{
  "app": {
    "name": "HUMIS",
    "tagline": "نظام ذكاء الإدارة البشرية"
  },
  "common": {
    "search": "ابحث عن موظفين، وحدات...",
    "globalSearch": "ابحث عن موظف أو قسم…",
    "save": "حفظ",
    "cancel": "إلغاء",
    "delete": "حذف",
    "edit": "تعديل",
    "create": "إنشاء",
    "close": "إغلاق",
    "confirm": "تأكيد",
    "actions": "إجراءات",
    "loading": "جارٍ التحميل...",
    "noData": "لا توجد بيانات",
    "error": "حدث خطأ ما",
    "retry": "إعادة المحاولة",
    "export": "تصدير",
    "viewAll": "عرض الكل",
    "today": "اليوم",
    "thisMonth": "هذا الشهر",
    "lastSixMonths": "آخر ٦ أشهر",
    "lastTwelveMonths": "آخر ١٢ شهرًا",
    "of": "من",
    "total": "الإجمالي",
    "rowsSelected": "{{count}} محدد"
  },
  "auth": {
    "signIn": "تسجيل الدخول",
    "signOut": "تسجيل الخروج",
    "email": "البريد الإلكتروني",
    "password": "كلمة المرور",
    "rememberMe": "تذكرني",
    "forgotPassword": "نسيت كلمة المرور؟",
    "forgotTitle": "إعادة تعيين كلمة المرور",
    "forgotSubtitle": "أدخل البريد الإلكتروني الذي تسجّل الدخول به. إذا كان له حساب، فسنرسل رابطًا لاختيار كلمة مرور جديدة.",
    "sendLink": "إرسال الرابط",
    "sending": "جارٍ الإرسال...",
    "forgotSent": "إذا كان لهذا البريد حساب، فقد أرسلنا إليه رابطًا. يعمل الرابط مرة واحدة وتنتهي صلاحيته خلال ساعة — تحقّق من مجلد الرسائل غير المرغوب فيها إن لم يصل.",
    "backToSignIn": "العودة إلى تسجيل الدخول",
    "resetTitle": "اختر كلمة مرور جديدة",
    "newPassword": "كلمة المرور الجديدة",
    "confirmPassword": "أعد كتابتها",
    "passwordsDiffer": "كلمتا المرور غير متطابقتين.",
    "setPassword": "تعيين كلمة المرور",
    "resetDone": "تم تغيير كلمة المرور وتسجيل خروجك من جميع الأجهزة. سجّل الدخول بكلمة المرور الجديدة.",
    "resetLinkIncomplete": "هذا الرابط غير مكتمل. افتح الرابط كاملًا من البريد، أو اطلب رابطًا جديدًا.",
    "requestNewLink": "طلب رابط جديد",
    "welcomeBack": "مرحبًا بعودتك، {{name}} 👋",
    "signingIn": "جارٍ تسجيل الدخول...",
    "invalidCredentials": "البريد الإلكتروني أو كلمة المرور غير صحيحة",
    "signInSubtitle": "سجّل الدخول إلى حسابك"
  },
  "nav": {
    "portal": "مساحتي",
    "dashboard": "لوحة التحكم",
    "employees": "الموظفون",
    "recruitment": "التوظيف",
    "attendance": "الحضور",
    "leave": "الإجازات",
    "timesheets": "الجداول الزمنية",
    "payroll": "الرواتب",
    "performance": "الأداء",
    "loans": "القروض والسلف",
    "assets": "الأصول",
    "documents": "المستندات",
    "exits": "إنهاء الخدمة",
    "compliance": "الامتثال",
    "reports": "التقارير والتحليلات",
    "settings": "الإعدادات",
    "administration": "إدارة النظام",
    "requests": "الطلبات",
    "pro": "المعاملات الحكومية",
    "compensation": "التعويضات",
    "expenses": "المصروفات والسفر",
    "settlements": "التسوية النهائية",
    "helpdesk": "مكتب الخدمة",
    "engagement": "المشاركة"
  },
  "dashboard": {
    "title": "لوحة التحكم",
    "downloadReport": "تنزيل التقرير",
    "totalEmployees": "إجمالي الموظفين",
    "presentToday": "الحاضرون اليوم",
    "onLeaveToday": "في إجازة اليوم",
    "absentToday": "الغائبون اليوم",
    "newJoiners": "الموظفون الجدد ({{month}})",
    "thisMonth": "{{count}} هذا الشهر",
    "percentOfTotal": "{{value}}٪ من الإجمالي",
    "fromLastMonth": "{{value}}٪ عن الشهر الماضي",
    "attendanceOverview": "نظرة عامة على الحضور",
    "employeeTrend": "اتجاه الموظفين",
    "upcomingEvents": "الأحداث القادمة",
    "leaveSummary": "ملخص الإجازات",
    "payrollSummary": "ملخص الرواتب",
    "recruitmentSummary": "ملخص التوظيف",
    "quickAccess": "وصول سريع",
    "departmentHeadcount": "عدد الموظفين حسب القسم",
    "recentActivities": "الأنشطة الأخيرة"
  },
  "a11y": {
    "skipToContent": "تخطَّ إلى المحتوى الرئيسي",
    "toggleSidebar": "تبديل الشريط الجانبي",
    "notifications": "الإشعارات، {{count}} غير مقروءة",
    "userMenu": "قائمة المستخدم",
    "settings": "الإعدادات",
    "expandSection": "توسيع {{section}}",
    "collapseSection": "طي {{section}}",
    "openCalendar": "فتح التقويم",
    "previousMonth": "الشهر السابق",
    "nextMonth": "الشهر التالي"
  },
  "validation": {
    "required": "هذا الحقل مطلوب",
    "email": "أدخل بريدًا إلكترونيًا صالحًا",
    "minLength": "يجب أن يكون {{count}} أحرف على الأقل"
  },
  "navChild": {
    "employees": {
      "directory": "الدليل",
      "orgChart": "الهيكل التنظيمي",
      "transfers": "التنقلات",
      "departments": "الأقسام",
      "divisions": "الشُعب",
      "legalEntities": "الكيانات القانونية",
      "establishments": "المنشآت",
      "masters": "البيانات التنظيمية الأساسية",
      "positions": "الوظائف"
    },
    "exits": {
      "cases": "الحالات",
      "settings": "الإشعار والإخلاء"
    },
    "compliance": {
      "calendar": "التقويم",
      "items": "الالتزامات",
      "nationalisation": "التوطين",
      "filings": "الإقرارات",
      "retention": "مراجعة الاحتفاظ",
      "requests": "طلبات البيانات"
    },
    "attendance": {
      "daily": "الحضور اليومي",
      "roster": "الورديات والجداول",
      "holidays": "العطلات",
      "regularisation": "تسوية الحضور",
      "devices": "الأجهزة",
      "sources": "مصادر البصمة",
      "feed": "البث المباشر",
      "reports": "التقارير",
      "kiosks": "أجهزة الحضور الذاتي",
      "geofencing": "النطاق الجغرافي والوجه"
    },
    "leave": {
      "requests": "الطلبات",
      "balances": "الأرصدة",
      "types": "أنواع الإجازات"
    },
    "timesheets": {
      "myWeek": "أسبوعي",
      "projects": "المشاريع",
      "approvals": "الاعتمادات"
    },
    "settings": {
      "dataMigration": "ترحيل البيانات",
      "general": "عام",
      "branding": "الهوية البصرية",
      "grants": "أدوار المستخدمين والصلاحيات",
      "segregation": "فصل المهام",
      "customFields": "الحقول المخصصة",
      "notifications": "الإشعارات",
      "banks": "البنوك",
      "ai": "الذكاء الاصطناعي والمساعد",
      "apiClients": "عملاء الواجهة البرمجية",
      "webhooks": "خطافات الويب",
      "sso": "الدخول الموحد",
      "erpExport": "تصدير إلى نظام المحاسبة"
    },
    "administration": {
      "users": "المستخدمون",
      "roles": "الأدوار والصلاحيات",
      "sessions": "الجلسات",
      "accessLog": "سجل الاطلاع",
      "auditLog": "سجل التدقيق",
      "workflows": "مسارات الاعتماد",
      "health": "حالة النظام"
    },
    "documents": {
      "expiring": "تنتهي قريبًا",
      "company": "وثائق الشركة",
      "types": "أنواع الوثائق",
      "credentialRules": "قواعد الوثائق المطلوبة",
      "letters": "قوالب الخطابات",
      "library": "المكتبة",
      "policies": "إقرارات السياسات",
      "librarySetup": "إعداد المكتبة",
      "signatures": "التوقيعات"
    },
    "requests": {
      "all": "كل الطلبات",
      "mine": "طلباتي",
      "types": "أنواع الطلبات"
    },
    "pro": {
      "cases": "لوحة المعاملات",
      "processes": "الإجراءات",
      "reports": "التقارير"
    },
    "performance": {
      "trainingNeeds": "الاحتياجات التدريبية",
      "appraisals": "تقييم الأداء",
      "goals": "الأهداف",
      "calibration": "المعايرة",
      "plans": "خطط التحسين",
      "setup": "الإعداد",
      "trainingCatalogue": "دليل الدورات",
      "trainingSessions": "جلسات التدريب",
      "trainingBudgets": "ميزانيات التدريب"
    },
    "reports": {
      "exports": "التصدير المجدول",
      "biAccess": "صلاحيات التقارير",
      "catalogue": "دليل التقارير",
      "builder": "منشئ التقارير"
    },
    "payroll": {
      "myPayslips": "قسائم راتبي",
      "runs": "دورات الرواتب",
      "elements": "عناصر الأجر",
      "provisions": "المخصصات والاستحقاقات",
      "chartOfAccounts": "دليل الحسابات",
      "wps": "تنسيقات حماية الأجور",
      "payments": "المدفوعات",
      "reports": "التقارير",
      "bankChannels": "قنوات البنك"
    },
    "compensation": {
      "bands": "نطاقات الأجور",
      "revisions": "مراجعات الرواتب",
      "benefits": "المزايا"
    },
    "loans": {
      "all": "القروض",
      "types": "أنواع القروض"
    },
    "expenses": {
      "claims": "المطالبات",
      "types": "الأنواع والحدود",
      "travel": "طلبات السفر",
      "perDiem": "بدل الإقامة اليومي"
    },
    "settlements": {
      "all": "التسويات",
      "terms": "شروط نهاية الخدمة"
    },
    "recruitment": {
      "overview": "نظرة عامة",
      "requisitions": "طلبات التوظيف",
      "candidates": "المرشحون",
      "offers": "العروض",
      "settings": "الإعدادات"
    },
    "assets": {
      "register": "السجل",
      "categories": "الفئات",
      "stocktakes": "الجرد",
      "reports": "التقارير"
    },
    "helpdesk": {
      "queue": "التذاكر",
      "knowledgeBase": "قاعدة المعرفة",
      "setup": "إعداد المكتب"
    },
    "engagement": {
      "announcements": "الإعلانات",
      "surveys": "الاستبيانات",
      "recognition": "التقدير"
    },
    "portal": {
      "home": "مساحتي",
      "punch": "تسجيل الحضور والانصراف",
      "myTeam": "فريقي",
      "delegation": "التفويض والغياب",
      "devices": "أجهزتي"
    }
  },
  "assistant": {
    "title": "المساعد",
    "open": "فتح المساعد",
    "newChat": "بدء محادثة جديدة",
    "history": "المحادثات السابقة",
    "noHistory": "لم تسأل عن أي شيء بعد.",
    "untitled": "محادثة بلا عنوان",
    "deleteConversation": "حذف هذه المحادثة",
    "askLabel": "اسأل المساعد",
    "placeholder": "اسأل عن إجازتك أو راتبك أو حضورك أو مستنداتك…",
    "send": "إرسال",
    "thinking": "جارٍ العمل على ذلك…",
    "failed": "حدث خطأ أثناء الإجابة. لم يتم تغيير أي شيء.",
    "lookedAt": "اطّلع على {{what}}",
    "wasThisUseful": "هل كان هذا مفيدًا؟",
    "thumbsUp": "كان مفيدًا",
    "thumbsDown": "لم يكن مفيدًا",
    "intro": "اسأل عن أي شيء تستطيع رؤيته في النظام. يرى المساعد ما تراه أنت فقط، لا أكثر.",
    "suggestions": [
      "كم يتبقى لي من الإجازة السنوية؟",
      "اشرح لي آخر كشف راتب",
      "ما الذي أحتاجه قبل تجديد الإقامة؟",
      "من سيكون في إجازة من فريقي الأسبوع القادم؟"
    ],
    "disclaimer": "يقرأ المساعد بياناتك بصلاحياتك أنت، ولا يغيّر أي شيء من تلقاء نفسه. أي تغيير يريد حفظه يُعرض عليك أولًا.",
    "proposal": {
      "untitled": "تغيير يقترحه المساعد",
      "confirm": "تأكيد",
      "cancel": "إلغاء",
      "notYetSaved": "لا يُحفظ أي شيء حتى تؤكّد.",
      "confirmed": "تم الحفظ.",
      "cancelled": "تم الإلغاء. لم يُحفظ شيء.",
      "expired": "انتهت صلاحية هذا الاقتراح قبل تأكيده. اسأل مرة أخرى لإعادته.",
      "failed": "تعذّر حفظ ذلك."
    }
  }
}
